import React, {memo, useState} from "react";
import ContentBox from "../../../Components/ContentBox/ContentBox";
import debug from "../../../Lib/debug";
import {customActions} from "../../../Lib/simplexion-table/templates/action-buttons";
import {FilterField} from "../../../Components/Table/FilterField";
import {SimplexionTable} from "../../../Lib/simplexion-table/SimplexionTable";
import {makeStyles} from "@material-ui/core";
import {makeTableStyles} from "../../../Components/Table/tableStyles";
import {baseTableStyles} from "../../../Lib/simplexion-table/baseStyle";
import {updatableCheckBoxStyle} from "../../../Lib/simplexion-table/templates/checkbox-input";
import {inputFieldStyles} from "../../../Lib/simplexion-table/templates/text-input";
import {useFacilityUnits} from "../../../Api/facility-units";
import LinearProgress from "@material-ui/core/LinearProgress";
import Section from "../../../Lib/form/Components/Section/Section";

const useTableStyles = makeStyles(makeTableStyles(baseTableStyles, updatableCheckBoxStyle, inputFieldStyles));

const List = memo((props) => {

    debug("RENDER", "useForm", () => [" -> List_Of_Facility_Units", props]);

    const {path, parentId, hasAdminRoles} = props;

    const {loadingStatus, data} = parentId ? useFacilityUnits({facility: parentId}) : [];

    const urlNs = path[2].url + '/';

    const tableClasses = useTableStyles();

    const [state, setState] = useState('');

    const handleFilter = val => setState(val);

    const tableConfig = {
        id: 'facility_units-table',
        nameSpace: 'facilityUnits',
        stickyHeader: true,
        sortable: true,
        styles: tableClasses,
        columns: [
            {
                accessor: 'id',
            },
            {
                accessor: 'erpId',
            },
            {
                accessor: 'designation',
            },
            {
                accessor: 'name',
            },
            {
                accessor: 'translStatus',
            },
            {
                accessor: 'action',
                renderer: (...args) => customActions(true, false, urlNs, ...args),
                sortable: true,
            },
        ],
    };

    return (
        <ContentBox path={path} add={hasAdminRoles ? (urlNs + "add") : null}>
            <Section>
                <FilterField handler={handleFilter}/>
                {loadingStatus > 0 ? <LinearProgress/> : null}
                <SimplexionTable tableConfig={tableConfig} data={data} loadingStatus={loadingStatus}
                                 filterValue={state}/>
            </Section>
        </ContentBox>
    );
});

export default List;